import PropTypes from "prop-types";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import useBreakpoints from "@util/breakpoints";
import { rem, em } from "@util/convertUnits";
import { buttonClick } from "@util/buttonClick";

const PageFooterMobileAccordian = ({ group, listStyle }) => {
	const theme = useTheme();
	const [isActive, setActive] = useState(false);

	const toggleClass = () => {
		setActive(!isActive);
	}

	const columnHeader_cta = useBreakpoints([theme.breakpoint.sm])({
		position: "relative",
		display: "block",
		paddingTop: [rem(12), 0],
		paddingBottom: [rem(12), 0],
		marginBottom: [0, em(24, 16)],
		fontFamily: theme.header.fontFamily,
		fontWeight: [600, 500],
		color: "#000000",
		textTransform: "uppercase",

		cursor: ["pointer", "default"],


		"span": {
			position: "absolute",
			top: "calc(50% - " + em(8, 16) + ")",
			right: "2.4rem",
			display: ["block", "none"],
			width: em(17, 16),
			height: em(16, 16),
			backgroundImage: ["url(/images/nav-icons/icon-plus.svg)", "none"],
			backgroundPosition: "center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "auto " + em(24, 16),
		},

		"&.active": {
			"& + ul": {
				display: ["block", "block"],
			},
			"span": {
				//transform: "rotate(180deg)",
				backgroundImage: ["url(/images/nav-icons/icon-minus.svg)", "none"],
			}
		},

		"& + ul": {
			display: ["none", "block"],
		}
	});

	return (
		<li>
			<span
				role="button"
				tabIndex="0"
				onKeyPress={buttonClick}
				onClick={toggleClass}
				className={isActive ? 'active' : null}
				css={columnHeader_cta}
			>
				{group.groupHeader}<span></span>
			</span>
			<ul css={listStyle}>
				{group.children.map((child) => (
					<li key={`${child.name}${child.url}`}>
						<a href={child.url}>{child.name}</a>
					</li>
				))}
			</ul>
		</li>
	);
};

PageFooterMobileAccordian.propTypes = {
	group: PropTypes.object,
	listStyle: PropTypes.array,
};

export default PageFooterMobileAccordian;